<div class="page-content">
  <div class="container-fluid">

    <!-- Page Title & Breadcrumb -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 class="mb-sm-0 font-size-18">Change Password</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a routerLink="/admin/admin-dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">Change Password</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Card -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body mt-3">
            <form #formStaffLogin="ngForm">
              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="row">

                    <mat-form-field appearance="outline" class="col-sm-12" subscriptSizing="dynamic">
                      <mat-label>Current Password</mat-label>
                      <input [type]="hideCurrentPassword ? 'password' : 'text'"
                        matInput #CurrentPassword="ngModel"
                        name="CurrentPassword"
                        [(ngModel)]="StaffLogin.CurrentPassword" required autofocus>
                      <button mat-icon-button matSuffix type="button"
                        (click)="hideCurrentPassword = !hideCurrentPassword">
                        <mat-icon>{{ hideCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                      @if ((CurrentPassword.dirty || CurrentPassword.touched) || CurrentPassword.invalid) {
                        <mat-error>Current Password is <strong>required</strong></mat-error>
                      }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-sm-12 mt-2" subscriptSizing="dynamic">
                      <mat-label>New Password</mat-label>
                      <input [type]="hideNewPassword ? 'password' : 'text'"
                        matInput #NewPassword="ngModel"
                        name="NewPassword"
                        [(ngModel)]="StaffLogin.NewPassword" required>
                      <button mat-icon-button matSuffix type="button"
                        (click)="hideNewPassword = !hideNewPassword">
                        <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                      @if ((NewPassword.dirty || NewPassword.touched) || NewPassword.invalid) {
                        <mat-error>New Password is <strong>required</strong></mat-error>
                      }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-sm-12 mt-2" subscriptSizing="dynamic">
                      <mat-label>Confirm New Password</mat-label>
                      <input [type]="hideNewConfirmPassword ? 'password' : 'text'"
                        matInput #NewConfirmPassword="ngModel"
                        name="NewConfirmPassword"
                        [(ngModel)]="StaffLogin.NewConfirmPassword" required>
                      <button mat-icon-button matSuffix type="button"
                        (click)="hideNewConfirmPassword = !hideNewConfirmPassword">
                        <mat-icon>{{ hideNewConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                      @if ((NewConfirmPassword.dirty || NewConfirmPassword.touched) || NewConfirmPassword.invalid) {
                        <mat-error>Confirm New Password is <strong>required</strong></mat-error>
                      }
                    </mat-form-field>

                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-footer text-center">
            <button mat-raised-button color="primary" (click)="changePassword()">
              Submit
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>